"use client";
import Image from "next/image";

import { createSharedPathnamesNavigation } from "next-intl/navigation";
export const { usePathname, Link } = createSharedPathnamesNavigation({
  locales: ["en", "ar"],
});
import React from "react";

export type LanguagePropsType = {
  name: string;
  key: string;
  icon: string;
};
function Language({ icon, name }: LanguagePropsType) {
  const pathname = usePathname();
  return (
    <div className={` flex-shrink-0  ease-in-out duration-700 `}>
      <Link href={pathname} locale={name}>
        <Image
          width={30}
          height={30}
          className="w-[30px] h-[30px] md:w-[40px] md:h-[40px]  lg:w-[2.9rem] lg:h-[2.9rem]"
          src={icon}
          alt={name}
        />
      </Link>
    </div>
  );
}

export default Language;
